import React from 'react'
import styled from 'styled-components'
import Modal, {ModalProps} from '@mui/material/Modal'
import modalStyles, {modalBoxStyles} from './modal.styles'

interface ApModalProps extends ModalProps {
  ap_type?:
    | 'special_instruction_modal'
    | 'best_date_modal'
    | 'standard_date_choice_modal'
    | 'location_modal'
    | 'notify_prefs_modal'
}

const ModalBox = styled.div`
  ${modalBoxStyles};
`
const apAtomName = {ap_atom_name: 'apModalAtom'}

const ModalAtom = styled((props: ApModalProps) => {
  return (
    <Modal {...apAtomName} {...props}>
      <ModalBox>{props.children}</ModalBox>
    </Modal>
  )
})`
  ${modalStyles};
`
export default ModalAtom
